import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  selectResultDrawer,
  closeResultDrawer,
  openEmailModal,
} from "../../../store/adminSlice";
import { apiClient } from "../../../utils/apiClient";
import { ResultDetailDrawer } from "./ResultDetailDrawer";
import type { PipelineResultLight, PipelineResultFull } from "./types";

export function ResultDetailDrawerWithHandlers() {
  const dispatch = useDispatch();
  const { open, resultId, input, resultIndex } = useSelector(selectResultDrawer);

  const [detailedResult, setDetailedResult] = useState<PipelineResultFull | null>(null);
  const [loading, setLoading] = useState(false);
  const [selectedResult, setSelectedResult] = useState<PipelineResultLight | null>(null);

  useEffect(() => {
    if (open && resultId && (input || resultIndex != null)) {
      fetchAutomationResult(resultId, input, resultIndex);
    } else {
      setDetailedResult(null);
      setSelectedResult(null);
    }
  }, [open, resultId, input, resultIndex]);

  const fetchAutomationResult = async (rid: string, inp: typeof input, idx: number | null) => {
    setLoading(true);
    try {
      const res = await apiClient.post<{ emailResult: PipelineResultFull }>(
        "/admin/email-automation/results/get-automation-result",
        { resultId: rid, input: inp ?? undefined, resultIndex: idx ?? undefined },
      );
      const full = res.emailResult;
      setDetailedResult(full);

      // Construct a minimal PipelineResultLight for the selectedResult prop
      setSelectedResult({
        emailId: full.emailId,
        emailSubject: full.emailSubject,
        gptRequestCount: full.gptRequests?.length || 0,
        notes: full.notes,
      });
    } catch (e) {
      console.error("Failed to fetch email result for global drawer:", e);
      setDetailedResult(null);
      setSelectedResult(null);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenEmail = (eid: string, _event: React.MouseEvent) => {
    dispatch(openEmailModal(eid));
  };

  const handleClose = () => {
    dispatch(closeResultDrawer());
  };

  return (
    <ResultDetailDrawer
      open={open}
      onClose={handleClose}
      selectedResult={selectedResult}
      detailedResult={detailedResult}
      loadingDetails={loading}
      onOpenEmail={handleOpenEmail}
      resultId={resultId ?? undefined}
    />
  );
}
